var _path, _circle, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    fill: "none",
    d: "M40.9 55.12a2.62 2.62 0 01-2.67 2.68l-1-.02a2.6 2.6 0 01-2.56-2.65l.2-11.18c0-.9-.36-1.76-1.02-2.36l-3.22-2.97a.64.64 0 01.45-1.12l7.43.13a2.6 2.6 0 012.56 2.65l-.22 12.6v.13l.05 2.1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.97,
    cy: 26.87,
    r: 5.13,
    className: "stroke fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    fill: "none",
    d: "M55.17 21.73a23.68 23.68 0 014.65 7.83M37.5 13.82c3.77 0 7.34.88 10.5 2.45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    fill: "none",
    d: "M9.43 50.67A31.02 31.02 0 0137.5 6.5c17.1 0 31 13.9 31 31a31.02 31.02 0 01-43.51 28.37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.e4575dae2f3bd20cfb333957b07fe0ee.svg";
export { ForwardRef as ReactComponent };